<template>
  <div class="container-login">
    <dialogWindow
      ref="ConfirmEmailDialog"
      :info="checkDialogTitle"
      size="max"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
  export default {
    components: {
      dialogWindow,
    },
    data: () => ({
      checkDialogColor: 'success',
      checkDialogTitle: '',
      userId: ''
    }),

    created() {
      this.confirmEmail();
    },

    mounted() {
    },

    methods: {
      confirmEmail() {
        const path = this.$route.path;
        const arrParams = path? path.split('/') : '';
        const usrId = arrParams[2]? arrParams[2] : '';
        const hashKey = arrParams[3]? arrParams[3] : '';
        const param = {usrId: usrId, hashKey: hashKey};
        this.userId = usrId;
        this.$store.dispatch('membership/confirmEmail', param).then((res) => {
          if (res.status === 0) {
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = res.message;
          } else {
            this.checkDialogColor = 'success';
            this.checkDialogTitle = res.message;
          }
          this.$refs.ConfirmEmailDialog.dialog = true;
          console.log("Confirm Email ok", res)
        }).catch((err) => {
          console.log("Confirm Email", err)
        });
      },
      closeDialog() {
        let userId = this.userId;
        if (this.checkDialogColor === 'warning') {
          this.$router.push({ path: `/resendemail/${userId}` });
        } else {
          this.$router.push('/login');
        }
      }
    }
  }
</script>